export default __webpack_public_path__ + "static/media/p49.950d8200.jpg";